import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import store from '../../../store';
import {conditional} from '../../../util/conditional';
import {selectSpcConfiguration} from '../../../selectors';
import {selectGroupedHeads, selectIomoHeads, selectIomoNumberOfHeads} from '../../iomoSelectors';


@customElement('iomo-specsheet-tender-text-page')
export class IomoSpecsheetTenderTextPage extends connect(store)(LitElement) {

	static styles = css`
		.pageContainer {
			display: flex;
			justify-content: space-between;
			width: 100%;
			gap: 1cqw;
			padding-top: 2cqw;
			container-type: inline-size;
		}
		.image {
			container-type: inline-size;
			width: 30%;
		}
		.sketch {
			width: 100%;
			display: block;
			padding: 0 15cqw 0 10cqw;
			box-sizing: border-box;
		}
		.tenderText {
			width: 70%;
		}
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.lang = state.status.lang;
		this.iomo = state.iomo.data;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
	}

	c(id) {
		return conditional(this.spcConfiguration, this.conditionalVariantValues, id);
	}

	render() {
		const s = this.state;
		return html`
			<div class="pageContainer">
				<div class="image">

				</div>

				<div class="tenderText">
					<iomo-tender-text></iomo-tender-text>
				</div>
			</div>
        `;
	}
}
